var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',_vm._b({staticClass:"min-h-screen max-w-none max-h-none h-auto",class:{
    'min-w-screen w-full': _vm.fullWidth,
    'md:hidden': _vm.only === 'desktop' && !_vm.isDesktop(),
    'object-cover': _vm.fit,
  },attrs:{"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},'video',_vm.attrs,false),[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }